import {createSelector} from 'reselect';
import GlobalState from '../../../root-state';

const selectResume = (state : GlobalState) => state.cashiers.resume;

export const cashierResumeSelector = createSelector(
    [selectResume],
    data => data
)
